"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = { activeIndex: null };
        GState.bind(this, [
            'user',
            'tenant',
            'workspace',
            'screen'
        ]);
        this.Menu = getMenu(this.state.tenant.settings.navigation || []);
    },
    onShowMenu: function (index) {
        this.state.activeIndex = this.state.activeIndex !== index ? index : null;
    },
    onNavigate: function (path) {
        navigate(path);
    },
    onAPICall: function ({target, call, args}) {
        try {
            GState[target][call](...args || []);
            this.onShowMenu(this.state.activeIndex);
        } catch (error) {
            debugLog(`Invalid GState API Method: <${ target }>`);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Admin/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_NavigationMenu = require("./menu.json"),
    NavigationMenu = module_NavigationMenu.default || module_NavigationMenu,
    Image_template = require("../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forRange = require("marko/dist/runtime/helpers/for-range"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    Footer_Admin_template = require("../../components/Footer-Admin.marko"),
    Footer_Admin_tag = marko_loadTag(Footer_Admin_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "overflow-hidden"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("aae1aa"),
    marko_node0 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "cursor-pointer"
      },
    marko_attrs2 = {
        "class": "col"
      },
    marko_attrs3 = {
        "class": "card item theme-bg shadow-none border"
      },
    marko_attrs4 = {
        "class": "card-content"
      },
    marko_attrs5 = {
        "class": "list-unstyled"
      },
    marko_attrs6 = {
        "class": "font-medium-4"
      },
    marko_attrs7 = {
        "class": "nav-item cursor-not-allowed"
      },
    marko_attrs8 = {
        "class": "px-2 py-75 font-medium-1"
      },
    marko_attrs9 = {
        "class": "bx bx-minus font-medium-2 text-muted mr-4 float-left"
      },
    marko_attrs10 = {
        "class": "nav-item cursor-pointer"
      },
    marko_attrs11 = {
        "class": "font-medium-1 px-2 py-75"
      },
    marko_attrs12 = {
        "class": "bx bx-minus font-medium-2 text-muted mr-4 float-left"
      },
    marko_attrs13 = {
        "class": "nav-item cursor-pointer"
      },
    marko_attrs14 = {
        "class": "font-medium-1 px-2 py-75"
      },
    marko_attrs15 = {
        "class": "bx bx-minus font-medium-2 text-muted mr-4 float-left"
      };

function Adapt( Menu, wsMode, sMedia ){
  const 
  RMap = {
    auto: { xl: 4, lg: 4, md: 3, sm: 2, xs: 1 },
    ns: { xl: 4, lg: 4, md: 2, sm: 2, xs: 1 },
    fs: { xl: 4, lg: 4, md: 2, sm: 2, xs: 1 },
    hs: { xl: 2, lg: 2, md: 1, sm: 2, xs: 1 },
    qs: { xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }
  },
  xCol = RMap[ wsMode ][ sMedia ],
  MLen = Menu.length,
  Mod = MLen % xCol,
  NItem = ( MLen - Mod ) / xCol,
  firstCol = NItem + Mod,
  columns = []

  let segment = 0

  for( let i = 0; i < xCol; i++ ){
    const
    xfrom = segment,
    xto = segment + ( i == 0 ? firstCol : NItem ) - 1

    columns.push({ xfrom, xto })
    segment = xto + 1
  }
  
  return { xCol, columns }
};

function getMenu( navigation ){
  return NavigationMenu.filter( ({ id, mandatory }) => { 
    return mandatory || (navigation || []).includes( id )
  } )
};

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        AutoScroll_tag({
            height: "100vh",
            class: "px-md-4 px-2 pb-4",
            renderBody: function(out) {
              Row_tag({
                  class: "m-0 d-flex align-items-center py-1",
                  col: [
                      {
                          hs: "col-xl-2 col-md-3",
                          class: "col-lg-1 col-md-2 col-3",
                          renderBody: function(out) {
                            Image_tag({
                                alt: "Image",
                                src: state.tenant.logo || "/images/default/institution.png",
                                class: "round",
                                style: "width:5rem;height:5rem"
                              }, out, __component, "5");
                          }
                        },
                      {
                          renderBody: function(out) {
                            out.be("h4", null, "7", component);

                            out.t(state.tenant.name, component);

                            Locale_tag({
                                text: "Admin",
                                class: "text-primary font-small-3 px-1"
                              }, out, __component, "8");

                            out.ee();
                          }
                        },
                      {
                          class: "col-4 d-md-block d-none",
                          renderBody: function(out) {
                            out.be("span", marko_attrs1, "10", component, null, 0, {
                                onclick: __component.d("click", () => window.Extensions.run('SuperProfile'), false)
                              });

                            Image_tag({
                                alt: getFullname(state.user),
                                src: state.user.photo,
                                class: "avatar float-right",
                                style: "width:3.4rem;height:3.4rem",
                                icon: "bx bx-user"
                              }, out, __component, "11");

                            out.ee();
                          }
                        }
                    ]
                }, out, __component, "3");

              out.n(marko_node0, component);

              const { xCol, columns } = Adapt( component.Menu, state.workspace.mode, state.screen.media )

              Row_tag({
                  class: "m-0",
                  renderBody: function(out) {
                    marko_forRange(1, xCol, 1, function(colx) {
                      out.be("div", marko_attrs2, "@" + colx, component);

                      const { xfrom, xto } = columns[ colx - 1 ]

                      marko_forRange(xfrom, xto, 1, function(index) {
                        const { title, icon, label, menu } = component.Menu[ index ]

                        var $keyValue$0 = "@" + index,
                            $keyScope$0 = "[" + ($keyValue$0 + "]");

                        out.be("div", marko_attrs3, $keyValue$0, component);

                        out.be("div", marko_attrs4, "14" + $keyScope$0, component);

                        out.be("div", {
                            "class": marko_classValue("card-header theme-bg cursor-pointer no-effect position-relative " + (state.activeIndex === index ? "border-bottom" : "")),
                            style: "z-index:1"
                          }, "15" + $keyScope$0, component, null, 1, {
                            onclick: __component.d("click", "onShowMenu", false, [
                                index
                              ])
                          });

                        Row_tag({
                            class: "d-flex align-items-center",
                            col: [
                                {
                                    class: "col-3",
                                    renderBody: function(out) {
                                      out.e("img", {
                                          src: "/images/icons/" + icon,
                                          "class": "img-fluid"
                                        }, "18" + $keyScope$0, component, 0);
                                    }
                                  },
                                {
                                    renderBody: function(out) {
                                      out.be("div", marko_attrs6, "20" + $keyScope$0, component);

                                      Locale_tag({
                                          text: title
                                        }, out, __component, "21" + $keyScope$0);

                                      out.ee();

                                      out.be("p", {
                                          "class": marko_classValue(marko_classValue([
                                            "m-0 animated fadeIn",
                                            state.activeIndex === index ? "d-none" : ""
                                          ]))
                                        }, "22" + $keyScope$0, component, null, 1);

                                      Locale_tag({
                                          text: label
                                        }, out, __component, "23" + $keyScope$0);

                                      out.ee();
                                    }
                                  }
                              ]
                          }, out, __component, "16" + $keyScope$0);

                        out.ee();

                        out.be("div", {
                            "class": marko_classValue("card-body px-0 pb-0 pt-1 animated slideInDown faster " + (state.activeIndex !== index ? "d-none" : ""))
                          }, "24" + $keyScope$0, component, null, 1);

                        out.be("ul", marko_attrs5, "25" + $keyScope$0, component);

                        var $for$0 = 0;

                        marko_forOf(menu, function(each, key) {
                          var $keyScope$1 = "[" + ((($for$0++) + $keyScope$0) + "]");

                          if (each.disabled) {
                            out.be("li", marko_attrs7, "@" + ("sub-" + key), component);

                            out.be("div", marko_attrs8, "26" + $keyScope$1, component);

                            out.e("i", marko_attrs9, "27" + $keyScope$1, component, 0);

                            Locale_tag({
                                text: each.label,
                                class: "text-muted"
                              }, out, __component, "28" + $keyScope$1);

                            out.ee();

                            out.ee();
                          } else if (each.gstate) {
                            out.be("li", marko_attrs10, "@" + ("sub-" + key), component, null, 0, {
                                onclick: __component.d("click", "onAPICall", false, [
                                    each.gstate
                                  ])
                              });

                            out.be("div", marko_attrs11, "29" + $keyScope$1, component);

                            out.e("i", marko_attrs12, "30" + $keyScope$1, component, 0);

                            Locale_tag({
                                text: each.label
                              }, out, __component, "31" + $keyScope$1);

                            out.ee();

                            out.ee();
                          } else {
                            out.be("li", marko_attrs13, "@" + ("sub-" + key), component, null, 0, {
                                onclick: __component.d("click", "onNavigate", false, [
                                    each.path
                                  ])
                              });

                            out.be("div", marko_attrs14, "32" + $keyScope$1, component);

                            out.e("i", marko_attrs15, "33" + $keyScope$1, component, 0);

                            Locale_tag({
                                text: each.label
                              }, out, __component, "34" + $keyScope$1);

                            out.ee();

                            out.ee();
                          }
                        });

                        out.ee();

                        out.ee();

                        out.ee();

                        out.ee();
                      });

                      out.ee();
                    });
                  }
                }, out, __component, "13");
            }
          }, out, __component, "2");

        Footer_Admin_tag({}, out, __component, "35", [
          [
            "help",
            "onFeedHelp",
            false
          ],
          [
            "feedback",
            "onFeedHelp",
            false
          ]
        ]);

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
